import { ln } from "api/endpoints";
import { importView } from "../utils/misc";

const AccountList = importView("account/List");
const AccountForm = importView("account/Form");
const ProdList = importView("product/List");
const ProdForm = importView("product/Form");
const LnClsList = importView("cls/List");
const TxnForm = importView("txn");
const CorrAccBaseInt = importView("txn/fin/AccBaseInt");
const CorrDueBaseInt = importView("txn/fin/DueBaseInt");
const CorrFineInt = importView("txn/fin/FineInt");
const CorrPrincBal = importView("txn/fin/PrincBal");
const CorrObFine = importView("txn/fin/ObFine");
const CorrObBase = importView("txn/fin/ObBase");
const PrvnPay = importView("txn/fin/PrvnPay");
const LnAcntToLo = importView("txn/nonfin/LnAcntToLo");

const lnRoutes = {
  path: "/",
  children: [
    {
      path: ln.cls,
      element: <LnClsList />,
    },
    {
      path: ln.accounts,
      element: <AccountList />,
    },
    {
      path: `${ln.account}/:AcntNo`,
      element: <AccountForm />,
    },
    {
      path: ln.products,
      element: <ProdList />,
    },
    {
      path: `${ln.product}/:ProdCode`,
      element: <ProdForm />,
    },
    {
      path: ln.finTxn,
      element: <TxnForm />,
    },
    {
      //! Зээлийн дансны хуримтлагдсан хүү залруулах
      path: ln.acntCorrBaseInt,
      element: <CorrAccBaseInt />,
    },
    {
      //! Зээлийн дансны хүүгийн өр залруулах
      path: ln.acntCorrDueBaseInt,
      element: <CorrDueBaseInt />,
    },
    {
      //! Зээлийн дансны нэмэгдүүлсэн хүү залруулах
      path: ln.acntCorrFineInt,
      element: <CorrFineInt />,
    },
    {
      //! Зээлийн дансны үлдэгдэл залруулах
      path: ln.acntCorrPrincBal,
      element: <CorrPrincBal />,
    },
    {
      path: ln.acntObFine,
      element: <CorrObFine />,
    },
    {
      path: ln.acntObBase,
      element: <CorrObBase />,
    },
    {
      path: ln.acntPrvnPay,
      element: <PrvnPay />,
    },
    {
      path: ln.acntChangeLo,
      element: <LnAcntToLo />,
    },
  ],
};

export default lnRoutes;
